import { useState, useEffect } from "react";
import queryString from "query-string";

export function useResponsivePageSize({
  defaultSmall = 14,
  defaultLarge = 20,
  breakpoint = 2000,
} = {}) {
  const getPageSizeFromUrl = () => {
    const parsed = queryString.parse(window.location.search);
    const ps = Number(parsed.pageSize);
    return isNaN(ps) || ps <= 0 ? null : ps;
  };

  const getDefaultPageSize = () => {
    return window.innerWidth > breakpoint ? defaultLarge : defaultSmall;
  };

  const [pageSize, setPageSize] = useState(() => {
    const fromUrl = getPageSizeFromUrl();
    return fromUrl ?? getDefaultPageSize();
  });

  useEffect(() => {
    const onResize = () => {
      const newPageSize = getDefaultPageSize();
      setPageSize((prev) => (prev !== newPageSize ? newPageSize : prev));
    };

    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return pageSize;
}
